<template>
  <div v-if="title" class="back df_flex df_align_flex_end">
    <div class="back_title">{{ title }}</div>
    <span class="back_click" @click="goBack">返回</span>
  </div>
  <div v-else class="back_navbar">
    <div class="back_navbar_click" @click="goBack">
      <i class="el-icon-back"></i>
      <slot>
        <span>返回</span>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BackNavbarDetails',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  methods: {
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
.back {
  padding: 70px 0 24px;

  &_title {
    font-size: 32px;
    font-weight: 600;
    line-height: 32px;
    color: #343847;
  }

  &_click {
    height: 18px;
    display: inline-block;
    margin-left: 12px;
    padding-left: 12px;
    border-left: 0.5px solid #8d96a7;
    font-size: 18px;
    line-height: 18px;
    color: #186dff;
    cursor: pointer;
  }
}

.back_navbar {
  width: 100%;
  padding: 70px 0 40px;
  position: relative;

  &_click {
    width: max-content;
    cursor: pointer;

    & > span,
    .el-icon-back {
      font-size: 16px;
      line-height: 16px;
      color: #5d6e96;
    }

    .el-icon-back {
      margin-right: 12px;
    }
  }
}
</style>
